import createIcon from '../../createIcon';

/**
 * @component @name LocalAtm
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgMTdIMTNWMTZIMTRDMTQuNTUgMTYgMTUgMTUuNTUgMTUgMTVWMTJDMTUgMTEuNDUgMTQuNTUgMTEgMTQgMTFIMTFWMTBIMTVWOEgxM1Y3SDExVjhIMTBDOS40NSA4IDkgOC40NSA5IDlWMTJDOSAxMi41NSA5LjQ1IDEzIDEwIDEzSDEzVjE0SDlWMTZIMTFWMTdaTTIwIDRINEMyLjg5IDQgMi4wMSA0Ljg5IDIuMDEgNkwyIDE4QzIgMTkuMTEgMi44OSAyMCA0IDIwSDIwQzIxLjExIDIwIDIyIDE5LjExIDIyIDE4VjZDMjIgNC44OSAyMS4xMSA0IDIwIDRaTTIwIDE4SDRWNkgyMFYxOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocalAtm = createIcon('LocalAtm', [
  [
    'path',
    {
      d: 'M11 17H13V16H14C14.55 16 15 15.55 15 15V12C15 11.45 14.55 11 14 11H11V10H15V8H13V7H11V8H10C9.45 8 9 8.45 9 9V12C9 12.55 9.45 13 10 13H13V14H9V16H11V17ZM20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V6H20V18Z',
      key: 'ni2pyf',
    },
  ],
]);

export default LocalAtm;
